import * as React from 'react';
import S from './TestimonialCard.styles';
const TestimonialCard = (props) => {
    if (!props.quote) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Quote, { dangerouslySetInnerHTML: { __html: props.quote } }),
        (props.name || props.role) && (React.createElement(S.Accrediation, null,
            props.name && React.createElement("span", null, props.name),
            props.role && React.createElement("span", null, props.role)))));
};
export default TestimonialCard;
